<template>
  <el-container style="width: 100%; height: 100%; position: fixed; top: 0">
    <el-header class="header">
      <el-row>
        <el-col :span="24">
          <router-link class="head-wrap" to="/">{{title}}</router-link>
          <el-dropdown trigger="click" @command="go" style="float: right;">
            <span class="user-name">
              {{user.userName}}[{{user.unitName}}]<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="/home/user-setting">
                <i class="user-icon fa fa-user-o"/>账户信息
              </el-dropdown-item>
              <el-dropdown-item command="/home/change-password">
                <i class="user-icon fa fa-key"/>修改密码
              </el-dropdown-item>
              <el-dropdown-item command="/home/software">
                <i class="user-icon fa fa-download"/>软件下载
              </el-dropdown-item>
              <template v-if="isSys">
                <el-dropdown-item divided></el-dropdown-item>
                <el-dropdown-item command="reloadPermits">
                  <i class="user-icon fa fa-refresh"/>重载权限
                </el-dropdown-item>
              </template>
              <el-dropdown-item divided></el-dropdown-item>
              <el-dropdown-item command="logout">
                <i class="user-icon fa fa-unlock"/>退出登陆
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span  style="float: right ; margin:0px 40px  0px  0px ; font-size: 18px; font-weight: bold; text-decoration: none; color: #fff;">
            <a :href="getGoodsHref(user.jwtToken,user.userId)" target="_blank"  style="text-decoration:none;color: #fff;">大数据界面</a>
         </span>
        </el-col>
      </el-row>
    </el-header>
    <el-container style="height: 100%;">
      <el-aside width="200px" style="background-color: #034C6A; border-right: solid 1px #e6e6e6;">
        <nav-menu/>
      </el-aside>
      <!--el-main-->
        <router-view  style="height: 100%;"/>
      <!--/el-main-->
    </el-container>
    <el-footer class="footer" height="20px">{{company}} CopyRight 2023 经营性备案号：琼B2-20030019</el-footer>
  </el-container>
</template>

<style scoped>
.header {
  background-color: #034C6A;
  color: #fff;
  line-height: 60px;
}
.footer {
  background-color: #034C6A;
  color: #fff;
  font-size: 9px;
  line-height: 20px;
  text-align: right;
}
.head-wrap {
  float: left;
  font-size: 24px;
  font-weight: bold;
  text-decoration:none;
  color: #fff;
}
.user-name {
  cursor: pointer;
  color: #F5F5F5;
}
.user-icon {
  margin-right: 10px;
}
</style>

<script>
import NavMenu from './navmenu.vue'
import store from '../store'
import SysApi from '@/api/sys'
import Utils from '@/utils/utils'

export default {
  components: { 'nav-menu': NavMenu },
  created() {
    //this.inited = (async () => {
      this.user = this.$store.getters.loginInfo
      this.isSys = Utils.getBit(this.user.permits, 0)
    //})()
  },
  async mounted() {
    //if (this.inited != undefined) {
    //  await this.inited
    //  delete this.inited
    //}
  },
  data() {
    return {
      title: document.title,
      company: document.getElementsByTagName('meta')['company'].content,
      user: undefined,
      isSys: false,
  }},
  methods: {
    go(path) {
      if (path[0] === '/') {
        this.$router.push(path)
      } else if (path === "logout") {
        this.$store.commit('logout')
        this.$router.push('/login')
      } else if (path === "reloadPermits") {
        this.reloadPermits()
      }
    },
    getGoodsHref:function(val,val2){
	    return '/data/index.html?userId='+val2+"&jwtToken="+val
	  },
    async reloadPermits() {
      const apiRes = (await SysApi.reloadPermits()).data
      if (apiRes.status === 0)
        await this.$alert('重新加载权限成功')
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/app-layout.vue